import React from 'react';

interface CrowdfundingListProps {
  onOpenProject: (projectId: number) => void;
}

// Interfața pentru un proiect de crowdfunding (versiune simplificată pentru listă)
interface CrowdfundingProjectPreview {
  id: number;
  titlu: string;
  descriereScurta: string;
  imagineUrl: string;
  sumaStransa: number;
  sumaTarget: number;
  zileRamase: number;
  sustinatori: number;
  utilizator: string;
  companie: string;
  taguri: string[];
}

const CrowdfundingList: React.FC<CrowdfundingListProps> = ({ onOpenProject }) => {
  // Proiecte exemplu
  const projects: CrowdfundingProjectPreview[] = [
    {
      id: 1,
      titlu: "Centru de inovație pentru antreprenorii din Vrancea",
      descriereScurta: "Un spațiu modern dedicat inovației și colaborării pentru comunitatea de afaceri din regiunea noastră.",
      imagineUrl: "/crowdfunding.png",
      sumaStransa: 35000,
      sumaTarget: 75000,
      zileRamase: 55,
      sustinatori: 47,
      utilizator: "Asociația Antreprenorilor din Vrancea",
      companie: "Patronat Vrancea",
      taguri: ["inovație", "startup", "coworking"]
    },
    {
      id: 2,
      titlu: "Târg anual de produse locale - Vrancea Manufacturing",
      descriereScurta: "Organizarea unui târg anual care să promoveze producătorii și meșteșugarii locali la nivel național.",
      imagineUrl: "/crowdfunding.png",
      sumaStransa: 12500,
      sumaTarget: 30000,
      zileRamase: 21,
      sustinatori: 28,
      utilizator: "Ion Gheorghe",
      companie: "Camera de Comerț Vrancea",
      taguri: ["marketing", "evenimente", "tradiții"]
    },
    {
      id: 3,
      titlu: "Program de digitalizare pentru micii producători",
      descriereScurta: "Asistență tehnică și cursuri pentru producătorii locali care vor să treacă la vânzare online și marketing digital.",
      imagineUrl: "/crowdfunding.png",
      sumaStransa: 8750,
      sumaTarget: 25000,
      zileRamase: 42,
      sustinatori: 15,
      utilizator: "Tech Hub Vrancea",
      companie: "Asociația IT Vrancea",
      taguri: ["digitalizare", "educație", "e-commerce"]
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow mb-6">
      <div className="p-4 border-b">
        <h2 className="text-xl font-semibold">Inițiative de crowdfunding</h2>
        <p className="text-gray-600">Proiecte comunitare care așteaptă susținerea ta</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
        {projects.map(project => (
          <div 
            key={project.id}
            className="border rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
            onClick={() => onOpenProject(project.id)}
          >
            <div className="relative">
              <img 
                src={project.imagineUrl} 
                alt={project.titlu}
                className="w-full h-40 object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-2">
                <div className="text-white text-xs">
                  Încă {project.zileRamase} zile
                </div>
              </div>
            </div>
            
            <div className="p-3">
              <h3 className="font-semibold text-lg mb-2 line-clamp-2 text-blue-600">{project.titlu}</h3>
              <p className="text-gray-600 text-sm mb-3 line-clamp-2">{project.descriereScurta}</p>
              
              <div className="mb-3">
                <div className="flex justify-between text-sm mb-1">
                  <span className="font-medium">{Math.round((project.sumaStransa / project.sumaTarget) * 100)}%</span>
                  <span>{project.sumaStransa} lei</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-1.5">
                  <div 
                    className="bg-blue-600 h-1.5 rounded-full" 
                    style={{width: `${Math.min(Math.round((project.sumaStransa / project.sumaTarget) * 100), 100)}%`}}
                  ></div>
                </div>
              </div>
              
              <div className="flex justify-between text-xs text-gray-500">
                <span>{project.sustinatori} susținători</span>
                <span>Inițiat de {project.companie}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="p-4 border-t text-center">
        <button className="text-blue-600 font-medium hover:text-blue-800">
          Vezi toate inițiativele →
        </button>
      </div>
    </div>
  );
};

export default CrowdfundingList;